
const menuConfigDict = {
    "Details": null,
    "Inspections": null,
    "Samples": "Field Samples",
    "Tests": "Field Tests",
    "Equipment": "Equipment",
    "Delays": "Delay",
    "Comments": "Comment",
    "Accidents": "Accident",
    "Contacts": null,
    "Contracts": null,
    "WorkItems": null,
    "Resources": null,
    "Issues": "Issue",
    "Documents": null,
    "Contractors": null,
    "Deliveries": "Material",
    "Checklist": "Checklist",
    "WorkItemTracking": "Work Item Tracking",
    "Observation": "Observations",
    "WorkforceLabor": "Workforce Labor",
    "WeatherImpact": "Weather Impact",
    "Visitor": "Visitor",
    "CommunicationEvent": "Communication Event",
    "Reports": null,
    "Configuration": null
};


const treeModules = ["Samples", "Tests", "Equipment", "Accidents", "Delays", "Comments", "Deliveries", "Issues", "Checklist", "WorkItemTracking", "Observation", "WorkforceLabor", "WeatherImpact", "Visitor", "CommunicationEvent"];


function checkHideShow (module, projectConfigurations) {

    const _module = `${module.slice(0,1).toUpperCase()}${module.slice(1,)}`;
    if(_module in menuConfigDict) {
        const label = menuConfigDict[_module];
       
        const match = projectConfigurations.find(config => config.label === label);
        if(match) {
            return match.value === "Show";
        } else {
            return true;
        }
    } else {
        console.error(`unkown module passed to checkHideShow(): "${module}"`);
        return true;
    }
};

function checkShowInspectionTreeIcon(projectConfigurations) {
    let showTree = false;
    treeModules.forEach(module => {
        const label = menuConfigDict[module];
        if(projectConfigurations.find(config => config.label === label && config.value === "Show")){
            showTree = true;
        };
    });
    return showTree;
}

function getNestedRoutes(currentModule, currentModuleFilter, selectedProject, module) {
    if(currentModuleFilter && currentModule.toLowerCase() === "inspections") {
        return `/projects/${selectedProject}/inspections/${currentModuleFilter}/${module}`
    } else {
        return `/projects/${selectedProject}/${module}`
    }
};

export { menuConfigDict, checkHideShow, checkShowInspectionTreeIcon, treeModules, getNestedRoutes };